<template>
  <div class="row">

    <div class="col-12" v-if="parentTickets && fullyLoaded">
      <div class="card" v-for="(ticket, t) in parentTickets">

        <div class="card-header hg-topline hg-underline" :style="topBottomOverride">
          <h3>{{ticket.details}}</h3>
        </div>

        <div v-for="(attendee, i) in ticket.attendees">

          <div class="col-12 mt-2">
            <h4 v-if="showGroupHeader(i, ticket)">Ticket Group: {{calcHeaderIndex(i, ticket)}}</h4>
          </div>

          <div class="col-12" style="padding: 0">
            <div class="card-header hg-underline" style="border: 0" :style="underlineOverride">
              <strong v-if="!attendee.registered_user_attributes.forename || !attendee.registered_user_attributes.surname">{{attendeeHeader(ticket, i)}} :</strong>
              <strong v-if="attendee.registered_user_attributes.forename && attendee.registered_user_attributes.surname">{{attendee.registered_user_attributes.forename}} {{attendee.registered_user_attributes.surname}}:
              </strong>

              <div v-if="!readonly" class="form-inline">
                <select class="form-control mb-3 attendees-select" name="people" id="people" v-model="attendee.selected" @change="populateDetails(attendee, ticket.id)">
                  <option value=null>--Add existing details to this ticket--</option>
                  <option v-if="bookerDetails" :value="bookerDetails">[BOOKER] {{bookerDetails.email}} ({{bookerDetails.forename}} {{bookerDetails.surname}}) </option>
                  <option v-for="user in validRegisteredUsers(ticket)" :value="user" :key="user.email">{{user.email}} ({{user.forename}} {{user.surname}})
                  </option>
                </select>
              </div>
            </div>

            <div class="card-body hg-bottomline-thin" :style="thinLineOverrides">


                  <div class="row">

                    <div class="col col-12 col-sm-6" v-for="col in formColumns">

                      <div class="form-group" v-if="showFieldForColumn(col, 'a')">
                        <label for="titledropdown">Title</label>
                        <select v-validate="'required'" class="form-control" data-vv-as="title" id="titledropdown" :name="'titledropdown' + t + '_' + i" required v-model="attendee.registered_user_attributes.title">
                          <option disabled selected style="display: none; color: red" value="">
                            --Please Select A Title --
                          </option>
                          <option value="Mr">
                            Mr
                          </option>
                          <option value="Mrs">
                            Mrs
                          </option>
                          <option value="Miss">
                            Miss
                          </option>
                          <option value="Ms">
                            Ms
                          </option>
                          <option value="Dr">
                            Doctor
                          </option>
                          <option value="Prof">
                            Professor
                          </option>
                          <option value="Other">
                            Other
                          </option>
                        </select>
                        <span v-show="errors.has('titledropdown' + t + '_' + i)" class="invalid-feedback">{{ errors.first('titledropdown' + t + '_' + i) }}</span>
                      </div>

                      <div class="form-group" v-if="showFieldForColumn(col, 'b')">
                        <label for="forename">Forename</label>
                        <input v-validate="'required'" data-vv-as="forename" class="form-control" id="forename" maxlength="100" :name="'forename' + t + '_' + i" placeholder="Name" type="text" v-model="attendee.registered_user_attributes.forename">
                        <span v-show="errors.has('forename'  + t + '_' + i)" class="invalid-feedback">{{ errors.first('forename' + t + '_' + i) }}</span>
                      </div>

                      <div class="form-group" v-if="showFieldForColumn(col, 'c')">
                        <label for="surname">Surname</label>
                        <input v-validate="'required'" data-vv-as="surname" class="form-control" id="surname" maxlength="100" :name="'lastname' + t + '_' + i" placeholder="Surname" type="text" v-model="attendee.registered_user_attributes.surname">
                        <span v-show="errors.has('lastname' + t + '_' + i)" class="invalid-feedback">{{ errors.first('lastname' + t + '_' + i) }}</span>
                      </div>

                      <div class="form-group" v-if="attendeeRegFields.company_enabled && showFieldForColumn(col, 'd')">
                        <label for="company">Company</label>
                        <input v-validate="'required'" data-vv-as="company" class="form-control" id="company" maxlength="100" :name="'company' + t + '_' + i" placeholder="Company" type="text" v-model="attendee.registered_user_attributes.company">
                        <span v-show="errors.has('company' + t + '_' + i)" class="invalid-feedback">{{ errors.first('company' + t + '_' + i) }}</span>
                      </div>

                      <div class="form-group" v-if="attendeeRegFields.job_enabled && showFieldForColumn(col, 'e')">
                        <label for="job">Job Title</label>
                        <input class="form-control" data-vv-as="job description" id="job" maxlength="100" :name="'job'  + t + '_' + i" placeholder="Job Title" type="text" v-model="attendee.registered_user_attributes.job_description">
                        <span v-show="errors.has('job'  + t + '_' + i)" class="invalid-feedback">{{ errors.first('job' + t + '_' + i) }}</span>
                      </div>

                      <div class="form-group" v-if="showFieldForColumn(col, 'f')">
                        <label for="login_email">Email</label>
                        <input v-validate="'required|email'" data-vv-as="email" class="form-control" id="login_email" maxlength="200" :name="'email'  + t + '_' + i" placeholder="Email" type="text" v-model="attendee.registered_user_attributes.email">
                        <span v-show="errors.has('email'  + t + '_' + i)" class="invalid-feedback">{{ errors.first('email' + t + '_' + i) }}</span>
                      </div>

                      <div class="form-group" v-if="attendeeRegFields.phone_enabled && showFieldForColumn(col, 'g')">
                        <label for="phone">Phone Number</label>
                        <input v-validate="'required'" class="form-control" data-vv-as="phone" id="phone" maxlength="15" :name="'phone' + t + '_' + i" placeholder="Phone Number" required="" type="text" v-model="attendee.registered_user_attributes.phone">
                        <span v-show="errors.has('phone'  + t + '_' + i)" class="invalid-feedback">{{ errors.first('phone' + t + '_' + i) }}</span>
                      </div>

                      <div class="form-group" v-if="attendeeRegFields.address1_enabled && showFieldForColumn(col, 'h')">
                        <label for="login_Address1">Address 1</label>
                        <input class="form-control" id="login_Address1" maxlength="100" data-vv-as="address 1" :name="'address1'  + t + '_' + i" placeholder="Address 1" required="" type="text" v-model="attendee.registered_user_attributes.address1">
                        <span v-show="errors.has('address1'  + t + '_' + i)" class="invalid-feedback">{{ errors.first('address1' + t + '_' + i) }}</span>
                      </div>

                      <div class="form-group" v-if="attendeeRegFields.address2_enabled && showFieldForColumn(col, 'i')">
                        <label for="login_Address2">Address 2</label>
                        <input class="form-control" id="login_Address2" maxlength="100" data-vv-as="address 2" :name="'address2'  + t + '_' + i" placeholder="Address 2" required="" type="text" v-model="attendee.registered_user_attributes.address2">
                        <span v-show="errors.has('address2'  + t + '_' + i)" class="invalid-feedback">{{ errors.first('address2' + t + '_' + i) }}</span>
                      </div>

                      <div class="form-group" v-if="attendeeRegFields.town_enabled && showFieldForColumn(col, 'j')">
                        <label for="login_town">Town/City</label>
                        <input class="form-control" id="login_town" maxlength="100" data-vv-as="town/city" :name="'town'  + t + '_' + i" placeholder="Town/City" type="text" v-model="attendee.registered_user_attributes.town">
                        <span v-show="errors.has('town'  + t + '_' + i)" class="invalid-feedback">{{ errors.first('town' + t + '_' + i) }}</span>
                      </div>

                      <div class="form-group" v-if="attendeeRegFields.county_enabled && showFieldForColumn(col, 'k')">
                        <label for="login_County">County</label>
                        <input class="form-control" id="login_County" maxlength="60" model="county" :name="'county'  + t + '_' + i" placeholder="County" required="" type="text" v-model="attendee.registered_user_attributes.county">
                        <span v-show="errors.has('county'  + t + '_' + i)" class="invalid-feedback">{{ errors.first('county' + t + '_' + i)}}</span>
                      </div>

                      <div class="form-group" v-if="attendeeRegFields.postcode_enabled && showFieldForColumn(col, 'l')">
                        <label for="login_PostCode">Postcode</label>
                        <input class="form-control" id="login_PostCode" maxlength="8" :name="'postcode'  + t + '_' + i" placeholder="PostCode" required="" type="text" v-model="attendee.registered_user_attributes.postcode">
                        <span v-show="errors.has('postcode'  + t + '_' + i)" class="invalid-feedback">{{ errors.first('postcode' + t + '_' + i) }}</span>
                      </div>

                      <div class="form-group" v-if="event.country_field && showFieldForColumn(col, 'm')">
                        <label for="countries">Country</label>
                        <b-form-select v-model="attendee.registered_user_attributes.country" text-field="name" :options="countries" />
                        <span v-show="errors.has('countries' + t + '_' + i)" class="invalid-feedback">{{ errors.first('countries' + t + '_' + i) }}</span>
                      </div>

                      <div v-for="(field, idx) in attendeeRegFields.dynamic_fields">

                        <div class="form-group" v-if="(field.question_type == 'text' || field.question_type == 'number') && showFieldForColumn(col, ('o' + idx))">
                          <label>{{field.title}}</label>
                          <input v-validate="event.attendee_questions_mandatory ? 'required' : ''" :name="`${field.title}_${i}`" class="form-control" maxlength="200" type="text" v-if="field.question_type=='text'" v-model="attendee.registered_user_attributes.registered_user_responses_attributes[idx].text" :data-vv-as="field.title">
                          <input v-validate="event.attendee_questions_mandatory ? 'required' : ''" :name="`${field.title}_${i}`" class="form-control" maxlength="200" type="number" v-if="field.question_type=='number'" v-model="attendee.registered_user_attributes.registered_user_responses_attributes[idx].text" :data-vv-as="field.title">
                          <span v-show="errors.has(`${field.title}_${i}`)" class="invalid-feedback">{{ errors.first(`${field.title}_${i}`)}}</span>
                        </div>

                        <div class="form-group" v-if="field.question_type == 'select' && showFieldForColumn(col, ('o' + idx))">
                          <label for="customs">{{field.title}}</label>
                          <select v-validate="event.attendee_questions_mandatory ? 'required' : ''" :name="`${field.title}_${i}`" class="form-control" v-model="attendee.registered_user_attributes.registered_user_responses_attributes[idx].selected_option" :data-vv-as="field.title">
                            <option v-for="f in field.options">
                              {{f}}
                            </option>
                          </select>
                          <span v-show="errors.has(`${field.title}_${i}`)" class="invalid-feedback">{{ errors.first(`${field.title}_${i}`)}}</span>
                        </div>
                      </div>


                </div>
             </div>
             <div class="row">
               <div class="col col-12">
                <b-card title="Additional Options" v-if="(ticket.child_tickets && ticket.child_tickets.length > 0) || (ticket.package_options && ticket.package_options.length > 0)" sub-title="Select additional options such as sub tickets and menu selections">
                  <child-ticket-view :event="event" v-if="ticket.child_tickets" :attendee="attendee" :ticket="ticket" :disabled="disabled"></child-ticket-view>
                  <ticket-options v-if="ticket" :ticket="ticket" :attendee="attendee" :attendeeIndex="i"></ticket-options>
                </b-card>
               </div>
              </div>
            </div>
          </div>

        </div>

      </div>

      <!--TODO change this-->
      <div v-if="tickets && tickets.length > 0" class="row">
        <div class="col col-12">
          <div class="card hg-topline" :style="topLineOverride">
            <div class="card-body" align="center">
              <div class="" style="margin-bottom:20px">
                <button v-if="!readonly" :style="{'background-color': event.buttoncolour, 'border-color': event.buttoncolour}" class="btn btn-primary btn-lg" @click.stop="saveAttendees" type="button">Save Attendee Details
                </button>
                <button v-if="readonly" :style="{'background-color': event.buttoncolour, 'border-color': event.buttoncolour}" class="btn btn-primary btn-lg" @click.stop="saveAttendees" type="button">Update Attendee Details
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ticketOptions from "./ticket-options.vue";
import bookingMixin from "../common/booking-mixin";
import childTicketView from "./child-ticket-view.vue";
import countries from "./../common/countries";
import {mapGetters} from 'vuex';
import _ from 'lodash'

export default {
  components: {
    ticketOptions: ticketOptions,
    childTicketView: childTicketView
  },

  mixins: [bookingMixin, countries],

  data: function() {
    return {
      event: this.$store.getters.getEvent,
      tickets: this.$store.getters.getSelectedTickets,
      eventBooking: this.$store.getters.getEventBooking,
      disabled: this.$store.getters.getReadOnly,
      fullyLoaded: false,
      posArray: [],
      fieldsCount: 4,
      splitValue: 0,
      registrationResponses: {},
      regFields: [],
      viewonly: false,
      submitted: false,
      formColumns: [1, 2],
      dynamicFields: [],
      attendeeRegFields: {
        dynamicFields: []
      },
      //Convenience to access these from attendees on the attendees on selectedPackages
      registeredUsers: [],
      regFields: [],
      readonly: this.$store.getters.getReadOnly,
      expired: this.$store.getters.getExpired,
      bookerDetails: Object.assign({}, this.$store.getters.getBookerDetails),
      mode: null
    };
  },

  created() {
    var _thisInt = this;

    var urlParams = new URLSearchParams(window.location.search);
    var modeParam = urlParams.get('mode');
    this.mode = modeParam;

    if (!this.tickets || this.expired) {
      this.$router.push({
        name: "home"
      });
      return;
    }

    //Disable for reg data
    if (this.readonly) {
      this.setUpRegUserDataReadOnly();
    } else {
      this.setUpRegUserData();
    }

    this.$http
      .get(
        "/static_reg_fields?event_id=" + this.event.id + "&field_type=attendee"
      )
      .then(response => {
        _thisInt.attendeeRegFields = response.data;
        // Get dyamic fields regardless
        _thisInt.getDynamicRegFields();
      })
      .catch(e => {
        // Get dyamic fields regardless
        _thisInt.getDynamicRegFields();
      });
  },

  computed: {
    ...mapGetters({
      hasPaidTickets: 'getChargeable'
    }),
    // These need to move out get a place of their own, get a job ..
    parentTickets() {
      return this.tickets.filter(ticket => !ticket.child_ticket);
    },
    topBottomOverride() {
      return {
        borderTop: "4px solid " + this.event.phcolour,
        borderBottom: "4px solid " + this.event.phcolour
      };
    },
    topLineOverride() {
      return { borderTop: "4px solid " + this.event.phcolour };
    },

    thinLineOverrides() {
      return { borderBottom: "2px solid " + this.event.phcolour };
    },

    underlineOverride() {
      return {
        borderBottom: "4px solid" + this.event.phcolour
      };
    }
  },

  methods: {
    // So if I have a group of 10 and 10x booked this should show 10 times for example
    showGroupHeader(idx, ticket) {
      return (
        ticket.group_amount > 1 &&
        // ticket.details_for_all_group_members &&
        (idx == 0 || idx % ticket.group_amount == 0)
      );
    },

    attendeeHeader(ticket, idx) {
      if (ticket.group_amount > 1 && !ticket.details_for_all_group_members) {
        return "Group " + (idx + 1) + " Contact";
      } else {
        return "Attendee " + (idx + 1);
      }
    },

    calcHeaderIndex(idx, ticket) {
      if (idx == 0) return 1;
      return idx / ticket.group_amount + 1;
    },

    getDynamicRegFields() {
      var self = this;
      self.$http
        .get(
          "/registration_fields?event_id=" +
            self.event.id +
            "&field_type=attendee"
        )
        .then(response => {
          self.dynamicFields = response.data;
          self.setUpData();
          self.fullyLoaded = true;
        })
        .catch(e => {
          // If not fields to load
          self.setUpData();
          self.fullyLoaded = true;
        });
    },

    validRegisteredUsers(ticket) {
      var filteredAttendees = this.registeredUsers.filter(
        attendeeOuter =>
          attendeeOuter.email &&
          attendeeOuter.forename &&
          attendeeOuter.surname &&
          attendeeOuter.ticket_id != ticket.id
      );

      filteredAttendees = _.uniq(filteredAttendees, 'email');

      if(this.bookerDetails){
        var pos = filteredAttendees.map(function(a) { return a.email; }).indexOf(this.bookerDetails.email);
        if(pos > -1) {
          filteredAttendees.splice(pos, 1);
        }
      }

      return filteredAttendees;
    },

    setUpData: function() {
      var _thisInt = this;

      this.posArray = [];
      this.regFields = [];
      this.fieldsCount = 4; //reset this if calling from outside
      this.splitValue = 0;

      this.attendeeRegFields.dynamic_fields = this.dynamicFields;

      if (this.attendeeRegFields.company_enabled) this.fieldsCount++;
      if (this.attendeeRegFields.job_enabled) this.fieldsCount++;
      if (this.attendeeRegFields.phone_enabled) this.fieldsCount++;
      if (this.attendeeRegFields.address1_enabled) this.fieldsCount++;
      if (this.attendeeRegFields.address2_enabled) this.fieldsCount++;
      if (this.attendeeRegFields.town_enabled) this.fieldsCount++;
      if (this.attendeeRegFields.county_enabled) this.fieldsCount++;
      if (this.attendeeRegFields.country_enabled) this.fieldsCount++;
      if (this.attendeeRegFields.postcode_enabled) this.fieldsCount++;

      if (this.dynamicFields && this.dynamicFields.length > 0) {
        this.fieldsCount = this.fieldsCount + this.dynamicFields.length;
      }

      this.splitValue = Math.ceil(this.fieldsCount / 2);

      this.formColumns = [1, 2];

      //Which reg fields, we need to get those for attendees

      if (this.dynamicFields && this.dynamicFields.length > 0) {
        var customFieldsSorted = this.dynamicFields.sort((n1, n2) => {
          if (n1.order_index > n2.order_index) {
            return 1;
          }
          if (n1.order_index < n2.order_index) {
            return -1;
          }
          return 0;
        });

        //Adds custom fields responses to the registered user attributes;

        _thisInt.setUpRegUserDynamicResponses(customFieldsSorted);

        customFieldsSorted.forEach(function(customField) {
          var optionVals = [];
          //TODO Should be filtered on server
          // Is this block needed?
          if (customField.field_type == "attendee") {
            if (customField.question_type == "select") optionVals = [];

            customField.options.forEach(function(optVal) {
              var opt = {
                nam: optVal,
                val: optVal
              };
              optionVals.push(opt);
            });

            var regField = {
              order_index: customField.order_index,
              field_id: customField.id,
              title: customField.title,
              field_type: customField.field_type,
              question_type: customField.question_type,
              mandatory: customField.mandatory,
              min_length: customField.min_length,
              max_length: customField.max_length,
              options: optionVals
            };

            _thisInt.regFields.push(regField);
          }
        });
      }
    },

    setUpRegUserDataReadOnly() {
      this.tickets.forEach(ticket => {
        if (!ticket.child_ticket) {
          ticket.attendees.forEach(attendee => {
            this.registeredUsers.push(attendee.registered_user_attributes);
          });
        }
      });
    },

    setUpRegUserData() {
      this.tickets.forEach(ticket => {
        ticket.attendees.forEach(attendee => {
          attendee.registered_user_attributes = {
            id: "",
            title: "",
            email: "",
            forename: "",
            surname: "",
            company: "",
            job_description: "",
            phone: "",
            address1: "",
            address2: "",
            town: "",
            county: "",
            postcode: "",
            country: "",
            po_number: "",
            user_type: "",
            ticket_id: ticket.id,
            registered_user_responses_attributes: []
          };
          this.registeredUsers.push(attendee.registered_user_attributes);
        });
      });
    },

    setUpRegUserDynamicResponses: function(customFieldsSorted) {
      // Sort the field responses correctly, extract to own function
      //This is necessary for correct ordering of responses
      this.tickets.filter(ticket => !ticket.child_ticket).forEach(ticket => {
        ticket.attendees.forEach(attendee => {
          var result = [];

          var attResponses =
            attendee.registered_user_attributes
              .registered_user_responses_attributes;
          if (attResponses && attResponses.length > 0) {
            customFieldsSorted.forEach(field => {
              var match = attResponses.find(
                resp => resp.registration_field_id == field.id
              );
              if (match) {
                result.push(match);
              }
            });
          }

          if (result.length > 0) {
            attendee.registered_user_attributes.registered_user_responses = result;
          }
        });
      });

      //End of section

      this.registeredUsers.forEach(regUser => {
        regUser.registered_user_responses_attributes = [];
        customFieldsSorted.forEach(customField => {
          if (regUser.registered_user_responses) {
            regUser.registered_user_responses_attributes =
              regUser.registered_user_responses;
          } else {
            regUser.registered_user_responses_attributes.push({
              registration_field_id: customField.id,
              text: "",
              selected_option: ""
            });
          }
        });
      });
    },

    //Extract common functions
    posit: function(posName) {
      if (this.posArray.indexOf(posName) == -1) {
        this.posArray.push(posName);
      }
      return this.posArray.indexOf(posName) + 1;
    },

    showFieldForColumn: function(col, position) {
      var pos = this.posit(position);

      if (pos == 0) {
        return true;
      }

      if (col == 1) {
        return pos <= this.splitValue;
      } else {
        return pos > this.splitValue;
      }
    },

    populateDetails(attendee, ticket_id) {
      if (attendee.selected) {
        if (attendee.selected.user_type == "booker") {
          this.processBooker(attendee, ticket_id);
        } else {
          this.processAttendee(attendee, ticket_id);
        }
      }
      this.$forceUpdate();
    },

    processAttendee(attendee, ticket_id) {
      this.registeredUsers.forEach(regUser => {
        if (
          regUser.email == attendee.selected.email &&
          regUser.forename == attendee.selected.forename &&
          regUser.surname == attendee.selected.surname
        ) {
          // Seems to need the assign to allow back selection from existing
          Object.assign(attendee.registered_user_attributes, attendee.selected);
          // attendee.registered_user_attributes = _.clone(attendee.selected);
          attendee.registered_user_attributes.ticket_id = ticket_id;
        }
      });
    },

    processBooker(attendee, ticket_id) {
      // Uses vue mixin method from bookings.js
      Object.assign(attendee.registered_user_attributes, attendee.selected);

      var regUser = attendee.registered_user_attributes;
      regUser.user_type = "attendee";
      regUser.ticket_id = ticket_id;
      regUser.id = null; //Removes id from booker if it is from an invite

      // Clear any fields not on form
      if (!this.attendeeRegFields.company_enabled) regUser.company = null;
      if (!this.attendeeRegFields.job_enabled) regUser.job_description = null;
      if (!this.attendeeRegFields.phone_enabled) regUser.phone = null;
      if (!this.attendeeRegFields.address1_enabled) regUser.address1 = null;
      if (!this.attendeeRegFields.address2_enabled) regUser.address2 = null;
      if (!this.attendeeRegFields.town_enabled) regUser.town = null;
      if (!this.attendeeRegFields.county_enabled) regUser.county = null;
      if (!this.attendeeRegFields.country_enabled) regUser.country = null;
      if (!this.attendeeRegFields.postcode_enabled) regUser.postcode = null;

      // Clears the fields from booker and replaces with blanks from attendee fields

      // TODO temp removal to test
      regUser.registered_user_responses_attributes = [];

      this.registeredUsers.push(regUser);

      this.regFields.forEach(regField => {
        regUser.registered_user_responses_attributes.push({
          registration_field_id: regField.field_id,
          text: "",
          selected_option: ""
        });
      });
    },

    saveAttendees: _.debounce ( function() {

      if (this.submitted || !this.validateMenuOptions(this.tickets)) {
        return false;
      }
      this.$store.commit("setSelectedTickets", this.tickets)
      this.submitted = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.hasPaidTickets && !this.readonly) {
            this.completeBooking(null, null, null);
          } else {
            if (this.readonly) {
              this.updateBooking(this.mode);
            } else {
              this.completeBooking(null, null, null, true);
            }
          }
          return;
        }
        this.$message.error("Please fix the validation issues");
        this.submitted = false
      });
    }, 500),

    validateMenuOptions(tickets) {
      var validMenuItems = true;

      tickets = tickets.filter(ticket => !ticket.child_ticket);

      tickets.forEach(ticket => {
        ticket.attendees.forEach(attendee => {
          var regUser = attendee.registered_user_attributes;
          if (
            ticket.package_options &&
            ticket.package_options.length > 0 &&
            validMenuItems
          ) {
            if (!regUser.menu_options_selected) {
              validMenuItems = false;
            } else {
              var allSelected = true;
              for(var i = 0; i < regUser.menu_options_selected.length; i++){
                if(regUser.menu_options_selected[i] === undefined){
                  allSelected = false;
                }
              }
              validMenuItems =
                (ticket.package_options.length ==
                regUser.menu_options_selected.length) && allSelected;  
            }
          }
        });
      });

      if (!validMenuItems) {
        this.$notify.error({
          message: "Please select all your menu options",
          title: "Choose Menu Options"
        });
      }

      return validMenuItems;
    }
  }
};
</script>

<style scoped>
/* Changes size of b-card title */
.card-title {
  font-size: 18px;
}
</style>
